import { render, staticRenderFns } from "./check-view.vue?vue&type=template&id=f53cac84"
import script from "./check-view.vue?vue&type=script&lang=js"
export * from "./check-view.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports